import React, { memo } from 'react';
import { Hash, Lock, AtSign, ChevronDown, Plus, Search, Edit3, MoreVertical, Smile, Paperclip, Send } from 'lucide-react';

const ChatContent = memo(({ activity }) => {
  const isTyping = activity?.action === 'type';
  const isScrolling = activity?.action === 'scroll';

  const channels = [
    { name: 'general', unread: 0, icon: Hash },
    { name: 'random', unread: 3, icon: Hash },
    { name: 'engineering', unread: 0, icon: Hash },
    { name: 'design', unread: 1, icon: Hash },
  ];

  const dms = [
    { name: 'Sarah Chen', status: 'online', unread: 2 },
    { name: 'Alex Rodriguez', status: 'away', unread: 0 },
    { name: 'Maya Patel', status: 'online', unread: 0 },
  ];

  const messages = [
    { user: 'Sarah Chen', time: '10:23 AM', text: 'Hey team! Just pushed the latest updates to the repo', avatar: '👩‍💼' },
    { user: 'Alex Rodriguez', time: '10:25 AM', text: 'Thanks! I\'ll review the PR this afternoon', avatar: '👨‍💻' },
    { user: 'Maya Patel', time: '10:27 AM', text: 'Looking good! The new design system is really coming together 🎨', avatar: '👩‍🔬' },
    { user: 'Sarah Chen', time: '10:30 AM', text: 'Agreed! Should we schedule a quick sync to discuss the rollout plan?', avatar: '👩‍💼' },
  ];

  return (
    <div className="slack-content">
      {/* Sidebar */}
      <div className="slack-sidebar">
        <div className="slack-workspace">
          <div className="workspace-name">
            <span>FluxSpace Team</span>
            <ChevronDown size={8} />
          </div>
        </div>

        <div className="slack-nav">
          <div className="nav-item">
            <Search size={8} />
            <span>Jump to...</span>
          </div>
        </div>

        <div className="slack-section">
          <div className="section-header">
            <ChevronDown size={6} />
            <span>Channels</span>
          </div>
          {channels.map((channel, i) => (
            <div key={i} className={`channel-item ${i === 0 ? 'active' : ''}`}>
              <channel.icon size={7} />
              <span className="channel-name">{channel.name}</span>
              {channel.unread > 0 && <span className="unread-badge">{channel.unread}</span>}
            </div>
          ))}
          <div className="add-channel">
            <Plus size={7} />
            <span>Add channels</span>
          </div>
        </div>

        <div className="slack-section">
          <div className="section-header">
            <ChevronDown size={6} />
            <span>Direct messages</span>
          </div>
          {dms.map((dm, i) => (
            <div key={i} className="dm-item">
              <div className={`dm-status ${dm.status}`}></div>
              <span className="dm-name">{dm.name}</span>
              {dm.unread > 0 && <span className="unread-badge">{dm.unread}</span>}
            </div>
          ))}
        </div>
      </div>

      {/* Main Chat Area */}
      <div className="slack-main">
        {/* Chat Header */}
        <div className="chat-header">
          <div className="chat-title">
            <Hash size={10} />
            <span>general</span>
          </div>
          <div className="chat-actions">
            <button className="header-btn"><Search size={8} /></button>
            <button className="header-btn"><MoreVertical size={8} /></button>
          </div>
        </div>

        {/* Messages */}
        <div className={`chat-messages ${isScrolling ? 'scrolling' : ''}`}>
          {messages.map((msg, i) => (
            <div key={i} className="message">
              <div className="message-avatar">{msg.avatar}</div>
              <div className="message-content">
                <div className="message-header">
                  <span className="message-user">{msg.user}</span>
                  <span className="message-time">{msg.time}</span>
                </div>
                <div className="message-text">{msg.text}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Message Input */}
        <div className="chat-input-container">
          <div className={`chat-input ${isTyping ? 'typing' : ''}`}>
            <button className="input-btn"><Smile size={8} /></button>
            <input 
              type="text" 
              placeholder="Message #general"
              defaultValue={isTyping ? 'Working on it now...' : ''}
            />
            <button className="input-btn"><Paperclip size={8} /></button>
            <button className="input-btn send"><Send size={8} /></button>
          </div>
        </div>
      </div>
    </div>
  );
});

ChatContent.displayName = 'ChatContent';

export default ChatContent;
